/**
 * A hook that gets the key name for a feature flag cookie.
 */
export const useFeatureCookieName = (featureName) => `x-msrc-feature-${featureName}`;
